<div class="custom-multi-select" [ngClass]="{ disabled: disabled }">
  @if(multiple){
    <div class="tags" #tagContainer>
      @if(selected.length){
        @for(item of selected; track item;){
          <span class="tag">
            {{ getLabelForValue(item) }}
            <button
              type="button"
              (click)="removeOption(item); $event.stopPropagation()"
              [disabled]="disabled"
            >
              ×
            </button>
          </span>
        }
      } @else {
        <span class="placeholder">{{ placeholder }}</span>
      }
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchTerm"
        (focus)="!disabled && (showDropdown = true)"
        (input)="!disabled && (showDropdown = true)"
        [placeholder]="placeholder"
        [disabled]="disabled"
      />
    </div>
    @if(showDropdown && filteredOptions.length && !disabled){
      <ul class="dropdown">
        @for(option of filteredOptions; track option;){
          <li (click)="selectOption(option)">
            {{ getLabel(option) }}
          </li>
        }
      </ul>
    }
  } @else {
    <div class="single-select">
      <div class="select-container">
        <select
          [disabled]="disabled"
          [ngModel]="selected.length ? selected[0] : null"
          (ngModelChange)="onSingleChange($event)"
          class="form-control"
        >
          @if(placeholder){
            <option [ngValue]="null" disabled hidden>
              {{ placeholder }}
            </option>
          }
          @for(option of options; track getValue(option)){
            <option [ngValue]="getValue(option)">
              {{ getLabel(option) }}
            </option>
          }
        </select>
      </div>
    </div>
  }
</div>
